/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Legajox_AbsencesInputs */

const es_tools_legajox_absences = /** @type {(inputs: Tools_Legajox_AbsencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consultando ausencias en Legajox...`)
};

const en_tools_legajox_absences = /** @type {(inputs: Tools_Legajox_AbsencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Querying Legajox absences...`)
};

/**
* | output |
* | --- |
* | "Querying Legajox absences..." |
*
* @param {Tools_Legajox_AbsencesInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_legajox_absences = /** @type {((inputs?: Tools_Legajox_AbsencesInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Legajox_AbsencesInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_legajox_absences(inputs)
	return en_tools_legajox_absences(inputs)
});
export { tools_legajox_absences as "tools.legajox.absences" }